import React from "react";
import { Box } from "@mui/material";
import { Page } from "../components/Page";
import { InteractiveCatalog } from "./InteractiveCatalog";

export function InteractiveList() {
  return (
    <Page
      title="Interactives"
      description="Interactive experiments and simulations"
    >
      <Box sx={{ maxWidth: "1200px", margin: "0 auto" }}>
        <InteractiveCatalog />
      </Box>
    </Page>
  );
}
